<template>
  <MenuLayout>
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div v-else>
      <!-- Start of job type register form -->
      <div class="row justify-content-center">
        <form class="card col-md-8 col-lg-6 col-sm-12 m-3 p-3">
          <h4 class="fw-bold mb-4">Job Type Register Form</h4>
          <div class="row mb-2">
            <label class="text-start col-md-4">Category<span class="text-danger">*</span></label>
            <div class="col-md-8">
              <select class="form-select form-select-sm col-md-12 selectBorder" v-model="jobTypeData.job_category_uid"
                required :class="{ 'is-invalid': error.categoryError }">
                <option v-for="categoryItem in jobCategoryList" :key="categoryItem.uid" :value="categoryItem.uid">
                  {{ categoryItem.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <label class="text-start col-md-4 form-label">Job Type<span class="text-danger">*</span></label>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-sm" v-model="jobTypeData.name" :maxlength="max_length.name"
                :class="{ 'is-invalid': error.typeError }" required />
            </div>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <button v-if="!updateMode && permission && (permission.data.job_create === 1)" class="btn btn-primary" v-on:click.prevent="add_update_data()">Register</button>
            <button v-if="updateMode && permission && (permission.data.job_update === 1)" class="btn btn-primary" v-on:click.prevent="add_update_data()">Update</button>
            <button v-if="updateMode || permission && (permission.data.job_create === 1)" class="btn btn-secondary me-0" v-on:click.prevent="cancel()">Cancel</button>
          </div>
        </form>
      </div>
      <!-- End of job type register form -->
      <!-- Start of job type register table -->
      <div class="col-xxl-10 offset-xxl-1">
        <table id="dataTable" class="table table-responsive">
          <thead>
            <tr>
              <th class="index-width">No</th>
              <th>Job Type</th>
              <th>Category</th>
              <th class="th-width"></th>
              <th class="th-width"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in jobTypeList" :key="index">
              <td class="text-center">{{ index + 1 }}</td>
              <td>{{ row.name }}</td>
              <td>
                <span v-for="jobCategory in jobCategoryList" :key="jobCategory.id">
                  <span v-if="row.job_category_uid === jobCategory.uid">
                    {{ jobCategory.name }}
                  </span>
                </span>
              </td>
              <td class="text-center">
                <i class="bi bi-pencil-square fs-6" data-toggle="tooltip" title="Edit" :class="{ 'disabled-btn': !permission || !permission.data || !permission.data.job_update}"
                v-on:click="show_data(row.uid)">
                </i>
              </td>
              <td class="text-center">
                <i class="bi bi-trash3-fill fs-6" data-toggle="tooltip" title="Delete" :class="{ 'disabled-btn': !permission || !permission.data || !permission.data.job_delete}"
                  v-on:click="delete_data(row)">
                </i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- End of job type register table -->
    </div>
    <loading-modal :loading="loading_model.process_loading" :loading_text="loading_model.loading_text"></loading-modal>
  </MenuLayout>
</template>
<style lang="css" scoped src="@/assets/css/jobReg.css">
</style>
<script>
import MenuLayout from "@/components/MenuLayout.vue";
import Configuration from "../Service/configuration.js";
import DataService from "../Service/data-service.js";
import ConstantVar from "@/Service/constant-var.js";
import Swal from "sweetalert2";
import { swal_option } from "@/Util/swal-option.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import { msg_code } from "@/Util/msg_code.js";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import LoadingModal from '@/components/LoadingModal.vue';
import { mapState } from "vuex";
var dataService = new DataService();
var config = new Configuration();
var con_var = new ConstantVar();
export default {
  components: {
    MenuLayout,
    LoadingSpinner,
    'loading-modal': LoadingModal,
  },
  data() {
    return {
      max_length: {},
      loading: null,//データの取得
      loading_model : {},
      jobCategoryList: [],
      jobTypeList: [],
      jobTypeData: {},
      error: {
        categoryError: false, //エラーカテゴリ入力を表示
        typeError: false, //エラージョブタイプ入力を表示
      },
      updateMode: false, //トレース更新モードへ
      tableHeaders: [],
    };
  },
  computed: {
        ...mapState(["userID","permission"]),
  },
  async mounted() {
    this.max_length = con_var.JOB_REG_MAX_LENGTH;
    this.loading = con_var.LOADING_INTI;
    this.loading_model = con_var.LOADING_MODEL;
    var serverResponse_job_type = await dataService.retrieveWithGet(config.SERVICE_NAME_JOB_TYPE);
    var serverResponse_job_category = await dataService.retrieveWithGet(config.SERVICE_NAME_JOB_CATEGORY);
    this.jobTypeList = serverResponse_job_type.data;
    this.jobCategoryList = serverResponse_job_category.data;
    this.fetchData();
    this.loading = false;
    this.initDataTableAfterFetch();
  },
  methods: {
    fetchData() {
      if (this.jobTypeList.length > 0) {
        this.headers = Object.keys(this.jobTypeList[0]);
      }
      this.tableHeaders = this.headers;
    },
    initDataTableAfterFetch() {
      this.$nextTick(() => {
        $(this.$el)
          .find("#dataTable")
          .DataTable({
            scrollX: true,
            scrollY: '450px',
            searching: true,
            columnDefs: [{ targets: [3,4], orderable: false }],
            language: {
              "info": "Page _PAGE_ of _PAGES_",
              paginate: {
                next: '&#x3e;', // or '>'
                previous: '&#x3c;' // or '<'
              },
              sLengthMenu: "_MENU_ ",
            },
          });
      });
    },
    validateForm() {//入力を検証する
      this.error.categoryError = false;
      this.error.typeError = false;
      let errorText = "";
      if (!this.jobTypeData.job_category_uid) {
        this.error.categoryError = true;
      }
      if (!this.jobTypeData || !this.jobTypeData.name || !this.jobTypeData.name.trim()) {
        this.error.typeError = true;
      }
      if (errorText) {
        Swal.fire({ ...swal_option("error", ""), html: errorText });
      }
      return !(this.error.categoryError || this.error.typeError); // 検証パス
    },
    async add_update_data() {
      if (!this.validateForm()) {
        return;
      }
      this.loading_model = {process_loading: true, loading_text: 'Processing'};
      var serverResponse;
      this.jobTypeData.updated_by = this.userID;
      if (this.jobTypeData.uid == null) { // 登録モード
        this.jobTypeData.created_by = this.userID;
        serverResponse = await dataService.callWithPost(config.SERVICE_NAME_JOB_TYPE, this.jobTypeData);
      } else { // 更新モード
        serverResponse = await dataService.updateWithPut(config.SERVICE_NAME_JOB_TYPE + "/" + this.jobTypeData.uid,
          this.jobTypeData);
      }
      if (serverResponse.success == true && serverResponse.error == false) {
        Swal.fire(swal_option("success", serverResponse.message));
        this.jobTypeList = serverResponse.data; // 一覧表にデータを更新する
        this.jobTypeData = {
          job_category_uid: null,
          name: null,
        };
        this.updateMode = false;
        var table = $("#dataTable").DataTable();
        table.destroy();
        this.fetchData();
        this.initDataTableAfterFetch();
      }
      else if (serverResponse.success == false && serverResponse.error == false) {
        Swal.fire(swal_option("warn", serverResponse.message));
      }
      else {
        Swal.fire(swal_option("error", msg_code("ef001")));
      }
      this.loading_model = con_var.LOADING_MODEL;
    },
    async show_data(uid) {
      this.loading_model = {process_loading: true, loading_text: 'Processing'};
      this.error.categoryError = false;
      this.error.typeError = false;
      var serverResponse = await dataService.retrieveWithGet(config.SERVICE_NAME_JOB_TYPE + "/" + uid);
      if (serverResponse.success == true) {
        this.jobTypeData = serverResponse.data;
        delete this.jobTypeData["created_at"];
        delete this.jobTypeData["updated_at"];
        this.updateMode = true;
      }
      else if (serverResponse.success == false && serverResponse.error == false) {
        Swal.fire(swal_option("warn", serverResponse.message));
      }
      else {
        Swal.fire(swal_option("error", msg_code("ef001")));
      }
      this.loading_model = con_var.LOADING_MODEL;
    },
    async delete_data(data) {
      var serverResponse = null;
        var delete_data = { "uid": data.uid };
        Swal.fire(swal_option("confirm", msg_code("cf003") + data.name + "?")).then(
          async (result) => {
            if (result.isConfirmed) {
              this.loading_model = {process_loading: true, loading_text: 'Processing'};
              serverResponse = await dataService.callWithPost(config.SERVICE_NAME_JOB_TYPE_DESTROY, delete_data);
              if (serverResponse.success == true) {
                Swal.fire(swal_option("success", serverResponse.message));
                this.jobTypeList = serverResponse.data;
                this.jobTypeData = {
                  job_category_uid: null,
                  name: null,
                };
                this.updateMode = false;
                var table = $("#dataTable").DataTable();
                table.destroy();
                this.initDataTableAfterFetch();
              }
              else if (serverResponse.success == false && serverResponse.error == false) {
                Swal.fire(swal_option("warn", serverResponse.message));
              }
              else {
                Swal.fire(swal_option("error", msg_code("ef001")));
              }
            }
            this.loading_model = con_var.LOADING_MODEL;
          }
        );
    },
    cancel() {
      this.jobTypeData = {
        job_category_uid: null,
        name: null,
      };
      this.updateMode = false;
      this.error.categoryError = false;
      this.error.typeError = false;
    },
  },
};
</script>
